import { useEffect } from 'react';
import axios from '../../Axios/axios';
import SessionStorageService from '../../Axios/SessionStorage';
import { loginUrl } from '../../constants/URLConstants';
import { setAlert } from '../../redux/actions/alert';
import {
  AUTH_LOADING,
  LOGIN_SUCCESS,
  WITH_SIDEBAR,
} from '../../redux/actions/types';
import store from '../../redux/store';

const { dispatch } = store;
const sessionStorageService = SessionStorageService.getService();

const OAuthCallback = () => {
  useEffect(() => {
    dispatch({ type: AUTH_LOADING });
    axios.authentication
      .getOAuthSession()
      .then((response) => {
        sessionStorageService.setAccessToken(response.data.access_csrf);
        sessionStorageService.setRefreshToken(response.data.refresh_csrf);
        sessionStorageService.setUserId(response.data.user_id);
        dispatch({ type: LOGIN_SUCCESS });
        dispatch({ type: WITH_SIDEBAR });
        dispatch({ type: AUTH_LOADING });
        window.location.href = '/projects';
      })
      .catch((error) => {
        dispatch(
          setAlert(
            'OAuth session error: ' +
              (error?.response?.data?.msg ?? error?.response?.data?.message),
            'danger',
          ),
        );
        window.location.href = loginUrl;
      });
  }, []);

  return <div></div>;
};

export default OAuthCallback;
